// extracted by mini-css-extract-plugin
module.exports = {"root":"EditListingBedFields_root__1hAlZ"};